export const ANCHOR_ATTR_NAME = 'data-anchor-id';
export const COMPONENT_NAME = 'owc-vertical-navigation';
export const INITIAL_SHOW_TIME = 3000;
export const SECTION_SHOW_TIME = 2000;
